import React from 'react';
import OwnerTrn from './OwnerTrn';

const TopText = ({
  companyNameError,
  companyTRNError,
  companyName,
  setCompanyName,
  companyTRN,
  setCompanyTRN,
  quotationError,
  // newInvoice,
  quotation,
  setQuotation,
  address,
  setAddress,
  addressError,
}) => {
  const currentDate = new Date();

  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Note: Months are zero-based
  const year = currentDate.getFullYear();

  const todaysDate = `${day}/${month}/${year}`;
  return (
    <div>
      <div className="flex mb-16 justify-between px-3 print:px-0 w-[640px] md:w-full print:w-full">
        <div className="flex-shrink-0 justify-between">
          <h1 className="text-black font-bold text-md">
            The Directory Business Setup
          </h1>
          <p className=" tracking-wide mt-2">
            {/* Office B-12B01 -Prime Business Center{' '} */}
            Office MF-63, Al Makhawi Building
          </p>
          <p className=" tracking-wide ">
            {/* JVC Dubai, UAE  */}
            Oud Mehta, P.O Box: 77106, Dubai-UAE
          </p>
          <OwnerTrn />
          {/* <p className=" tracking-wide ">TRN - 100338057100003 </p> */}
        </div>
        <div className="">
          <h2 className="text-3xl font-bold text-center mb-3">Quotation</h2>
          <table>
            <thead>
              <tr>
                <th
                  className="text-black px-10 bg-gray-300 border border-black"
                  align="center"
                >
                  Date
                </th>

                <th
                  className="text-black px-10 bg-gray-300 border border-black"
                  align="center"
                >
                  Quotation #
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-black py-2 text-sm" align="center">
                  {todaysDate}
                </td>
                <td
                  className="border border-black py-2 text-sm "
                  align="center"
                >
                  <span className="ml-1 hidden print:block">{quotation}</span>
                  <input
                    type="text"
                    value={quotation}
                    onChange={(e) => setQuotation(e.target.value)}
                    className="border max-w-[100px] border-gray-300 pl-1 print:hidden ml-1"
                    placeholder="Quot. Numb"
                  />
                  {quotationError && (
                    <p className="ml-1 text-xs text-red-600 animate__animated animate__fadeIn">
                      {quotationError}
                    </p>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* To whom Table */}
      <div className="px-3 print:px-0">
        <table>
          <thead>
            <tr>
              <th
                className="font-normal pl-2 w-[350px]  border border-black"
                align="left"
              >
                <div className="flex ">
                Bill To :&nbsp;
                <span className="hidden print:block">{companyName}</span>
                <input
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  className="border border-gray-300 px-2 py-1 print:hidden ml-1"
                  placeholder="Company Name"
                />
                {companyNameError && (
                  <p className="ml-1 text-xs text-red-600 animate__animated animate__fadeIn">
                    {companyNameError}
                  </p>
                )}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border-x border-black   text-xs pl-1" align="left">
                <div className="flex ml-1">
                  Address :&nbsp;
                  <span className=" hidden print:block">{companyName}</span>
                  <input
                    type="text"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className="border border-gray-300 px-2 py-1 print:hidden ml-1"
                    placeholder="Address"
                  />
                  {addressError && (
                    <p className="ml-1 text-xs text-red-600 animate__animated animate__fadeIn">{addressError}</p>
                  )}
                </div>
              </td>
            </tr>
            <tr>
              <td
                className="border-x border-b border-black   text-xs pl-1 pb-12"
                align="left"
              >
                <div className="flex ml-1">
                  TRN :&nbsp;
                  <span className=" hidden print:block">{companyTRN}</span>
                  <input
                    type="number"
                    value={companyTRN}
                    onChange={(e) => {
                      const { value } = e.target;
                      setCompanyTRN(value);
                    }}
                    onKeyDown={(event) => {
                      if (event.key === 'e' || event.key === 'E' || event.key === '-') {
                        event.preventDefault();
                      }
                    }}
                    className="border border-gray-300 px-2 py-1 print:hidden "
                    placeholder="Company TRN"
                  />
                {companyTRNError && (
                  <p className="ml-1 text-xs text-red-600 animate__animated animate__fadeIn">{companyTRNError}</p>
                )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopText;
